
//******************Exchange Rate Server Calls******************;

import {InvoiceDetailsActions} from './InvoiceDetailsConstants';
import store from '../../Store/store'
import {ROOT_URL, getCookie} from '../../Config/Config';
import {failure_messages} from "Messages"


export const InvoiceDetailsServer = {
  //  getInvoiceDetails:getInvoiceDetails,
  getInvoiceDetails:getInvoiceDetails,
  //  updateInvoiceDetails:updateInvoiceDetails
};

//******************Insert InvoiceDetailss******************;

function getInvoiceDetails(data){
      const request=fetch(ROOT_URL+'/api/businessInvoices/getInvoiceFeesById', {
          method: 'Post',
          mode: 'cors',
          headers: { 
            'authorization':getCookie("admin_token_partner"),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
          }).then((response)=>{
           response.json().then(response=>{
             if(response.status == "200"){
             // alert(JSON.stringify(response))
            store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.SUCCESS,payload:response.data});
            return ;
            }else
            {
              store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.FAILED, error:response.error});
              return ;
              }    
           });
          }).catch((error) => {
          //  alert(error)
           store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.FAILED, error:failure_messages.unExpectedError});
            })
      return {type:InvoiceDetailsActions.InvoiceDetails_GET.LOADING}

};
  
//******************Get InvoiceDetailss******************;


//******************Update InvoiceDetails******************;

  
// function getInvoiceDetails(){
//       const request=fetch(ROOT_URL+'/api/exchangeRate/getExchangeRate/', {
//           method: 'GET',
//           mode: 'cors',
//           headers: {'Content-Type':'application/json'},
//          // body: JSON.stringify(data)
//           }).then((response)=>{
//             response.json().then(response=>{
//               if(response.status == "200"){
//                 console.log(response)
//                 if(response.InvoiceDetails.length>0)
//              store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_Get.SUCCESS,payload:response.InvoiceDetails});
//              else
//              store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.NEW});
             
//              return ;
//              }else
//              {
//                store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_Get.FAILED});
//                return ;
//                }    
//             });
//            }).catch((error) => {
//             store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_Get.FAILED});
//           })
//        return {type:InvoiceDetailsActions.InvoiceDetails_GET.LOADING}
 
//     };
  
// function updateInvoiceDetails(data){
//   const request=fetch(ROOT_URL+'/api/exchangeRate/BulkUpdateExchangeRate', {
//     method: 'Post',
//     mode: 'cors',
//     headers: {'Content-Type':'application/json'},
//     body: JSON.stringify(data)
//     }).then((response)=>{
//      response.json().then(response=>{
//        if(response.status == "200"){
//          console.log(response)
//       store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.SUCCESS});
//       return ;
//       }else
//       {
//         store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.FAILED});
//         return ;
//         }    
//      });
//     }).catch((error) => {
//       store.dispatch({type:InvoiceDetailsActions.InvoiceDetails_GET.FAILED});
//     })
// return {type:InvoiceDetailsActions.InvoiceDetails_GET.LOADING}

// };
